import React, { useState } from "react";
import { Box, Button, TextField, Toolbar, Typography } from "@mui/material";
import BackButton from "../../components/common/BackButton";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useAxios } from "../../hooks";
import Switch from "@mui/material/Switch";

const CreateNewAnnoucement = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const api = useAxios({ autoSnackbar: true });
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    subject: "",
    body: "",
    is_public: true,
  });
  const [data, setData] = useState({ subject: "", body: "", is_public: "" });

  const [isPublic, setIsPublic] = useState(true);

  const handleOnChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  useQuery(
    `annoucement-details_${id}`,
    () => {
      if (id) {
        return api
          .get(`/api/announcement/i/${id}`)
          .then((response) => response.data);
      }
    },
    {
      onSuccess: (data) => {
        if (data) {
          setFormData({
            subject: data.subject,
            body: data.body,
            is_public: data.is_public,
          });
          setIsPublic(data.is_public);
        }
      },
    }
  );

  const { mutate: addNew } = useMutation(
    (formData) => {
      return api.post(`/api/announcement/i`, formData);
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(`internal-announcement_list`);
      },
    }
  );

  const { mutate: editAnnouncement } = useMutation(
    (formData) => {
      return api.put(`api/announcement/i/${id}`, formData);
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(`internal-user_list`);
        setData({
          subject: formData.subject,
          body: formData.body,
          is_public: formData.is_public,
        });
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    let requestData = { ...formData };

    if (id) {
      requestData.is_public = isPublic;
      editAnnouncement(requestData);
    } else {
      requestData.is_public = isPublic;
      addNew(requestData);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: {
          xs: "100%",
          sm: "60%",
          md: "30%",
        },
        p: 2,
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
        variant="dense"
        disableGutters={true}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          <BackButton backFunction={() => navigate(-1)} />
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            {id ? "Edit" : "Add New"} Announcement
          </Typography>
        </Box>
      </Toolbar>

      <Typography
        variant="subtitle2"
        fontWeight="bold"
        sx={{
          marginTop: "20px",
          marginBottom: "8px",
          color: "secondary.light",
        }}
      >
        Subject
      </Typography>
      <TextField
        name="subject"
        value={formData?.subject}
        onChange={handleOnChange}
        label=""
        size="small"
        sx={{
          width: "100%",
          "& .MuiInputBase-root": {
            backgroundColor: "#F0F0F0",
          },
        }}
      />
      <Box>
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          sx={{
            marginTop: "20px",
            marginBottom: "8px",
            color: "secondary.light",
          }}
        >
          Body
        </Typography>
        <TextField
          name="body"
          multiline
          rows={5}
          value={formData?.body}
          onChange={handleOnChange}
          label=""
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              backgroundColor: "#F0F0F0",
            },
          }}
        />
      </Box>

      <Box>
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          sx={{
            marginTop: "20px",
            marginBottom: "8px",
            color: "secondary.light",
          }}
        >
          Is Public
        </Typography>
        <Switch checked={isPublic} onChange={() => setIsPublic(!isPublic)} />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "20px",
          mt: 2,
          width: "100%",
          justifyContent: { xs: "center", lg: "space-between" },
        }}
      >
        <Button
          variant="contained"
          type="submit"
          sx={{
            flex: 1,
            height: 35,
            boxShadow: "none",
          }}
          onClick={() => navigate(-1)}
        >
          {id ? "Edit" : "Create"}
        </Button>
        <Button
          color="error"
          variant="outlined"
          fullWidth
          sx={{
            flex: 1,
            height: 35,
          }}
          onClick={() => navigate(-1)}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default CreateNewAnnoucement;
